(function ($) {
	$.stickyMenu = function (element, options) {
		// **************************************************************
		// Public Properties
		// **************************************************************

		var $c = $(element), // Context 

			StickyMenu = (function ($c, o) {
				var defaults = {
					header: '.header',
					brand: '.brand',
					cover: '.cover',
					content: '.content',
					background: '.background',
					scrollButton: '.scroll-button'
				}; 

				var _o = {},
					wh = 0, // Window Height
					hh = 0, // Header Height
					my = 0, // Maximum Y

					wp = null, // Waypoint
					tl = null, // Timeline Scroll
					tlb = null, // Timeline Brand

					$w = null, // Window
					$h = null, // Header
					$b = null, // Body

					$br = null, // Brand
					$cv = null, // Cover
					$ct = null, // Content
					$bg = null, // Background
					$sb = null // Scroll Button
				;

				var _InitObjects = function () {
					_o = $.extend({}, defaults, o);
					
					$w = $(window);
					$h = $(_o.header);
					$b = $('body');

					$br = $(_o.brand);
					$cv = $(_o.cover, $c);
					$ct = $(_o.content, $c);
					$bg = $(_o.background, $c);
					$sb = $(_o.scrollButton, $c);

					_GetMeasurements();
					_SetCushion();

					_BuildTimeline();
				},

				_GetMeasurements = function() {
					wh = $c.height();
					hh = $h.height();
					my = wh - hh;
				},

				_SetCushion = function() {
					$b.css('padding-top', wh);
				},

				_BuildTimeline = function() {
					if (tl) { tl.clear(); }
					tl = new TimelineLite({ paused: true, useFrames: true });

					tl.add('start')
						.set($c, { css: { y: 0 } } )
						.set($bg, { css: { y: 0 } } )
						.set($sb, { css: { y: 0 } } )
						//.set($ct, { css: { y: 60 } } )

						.add(new TweenLite($c, my, { css: { y: -my }, ease: Linear.easeNone }), 'start')
						.add(new TweenLite($bg, my, { css: { y: my }, ease: Linear.easeNone }), 'start')
						.add(new TweenLite($sb, my, { css: { y: my }, ease: Linear.easeNone }), 'start')
						.add(new TweenLite($ct, my, { css: { y: my * .6 }, ease: Linear.easeNone }), 'start')
						.add(new TweenLite($cv, my, { css: { opacity: .8 }, ease: Power1.easeIn }), 'start')
					;

					if (tlb) { tlb.clear(); }
					tlb = new TimelineLite({ pause: true });
					tlb.add(new TweenLite($br, .8, { css: { yPercent: -50 }, ease: Expo.easeInOut }));
				},

				_SetScrollPosition = function() {
					var st = $w.scrollTop(),
						f = Math.floor(st)
					;

					if (f <= my) {
						tl.stop().seek(f);
					} else {
						tl.seek(my);
					}
				},

				_OnWayPoint = function(direction) {
					$b.toggleClass('scrolled');
					if (direction === 'down') {
						tlb.play();
					} else {
						tlb.reverse();
					}
				},

				_OnWindowScroll = function(e) {
					_SetScrollPosition();
				},

				_OnWindowResize = debounce(function(e) {
					_GetMeasurements();
					_SetCushion();

					_BuildTimeline();
					_SetScrollPosition();
				}, 250),

				_BindEvents = function () {
					// Set waypoint
					wp = new Waypoint({
						element:  $c.next().get(0),
						handler: _OnWayPoint,
						offset: hh
					});

					$w.scroll(_OnWindowScroll);
					$w.resize(_OnWindowResize);
				},

				init = (function() {
					_InitObjects();
					_BindEvents();
				})();
			}) ($c, options);
	};

	$.fn.stickyMenu = function (options) {
		return this.each(function () {
			if (undefined === $(this).data('stickyMenu')) {
				var plugin = new $.stickyMenu(this, options);
				$(this).data('stickyMenu', plugin);
			}
		});
	};
})(jQuery);
